import { IEventCollectionDataActiveEvents } from 'meta/pages/v4/eventCollection'

export const getFirstCollectionRelatedEventCode = (data: Record<number, IEventCollectionDataActiveEvents>): string => {
  return Object.values(data).flat()[0].items[0].code
}
